import { render } from "./MdDialogAlert.vue?vue&type=template&id=95a633c0"
import script from "./MdDialogAlert.vue?vue&type=script&lang=js"
export * from "./MdDialogAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__